
export { default } from './placeholder';


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/placeholder/index.js
// module id = 764
// module chunks = 1